import { get, put } from '../Services/http';
import { catchError } from './Error.action';
import {
    CART_LOAD_ERROR,
    CART_RECEIVE,
    CART_SHOW_INFO,
    CART_UPDATE_QUANTITY,
} from '../constants';
import { setPaymentUpdating } from './Checkout.action';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then((response) => response.json())
        .then((cart) => {
            dispatch(receive(cart));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (cart) => ({
    type: CART_RECEIVE,
    payload: cart,
});

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
};

const show = (visible) => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    },
});

export const update = (articleNumber, quantity, abortController = null) => (
    dispatch
) => {
    dispatch(setPaymentUpdating(true));
    return put(`/api/cart/update`, { articleNumber, quantity }, abortController)
        .then((response) => response.json())
        .then((cart) => dispatch(receive(cart)))
        .catch((ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
            throw ex;
        })
        .finally(() => {
            dispatch(setPaymentUpdating(false));
            dispatch(load());
        });
};

export const updateQuantity = (articleNumber, quantity) => ({
    type: CART_UPDATE_QUANTITY,
    payload: {
        articleNumber: articleNumber,
        quantity: quantity,
    },
});
